module.exports = __webpack_public_path__ + "img/pont-neuf.027006af.jpg";